export default {
  'MultipleOptionsButton.Option': ({ option, allowEdit }, outlet) => {
    if (!allowEdit) return;
    outlet({ option })
  }
}